import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canSeeTags, canViewAdminDashboardOrganizations } from '../permissions';

export const useOrganizationsPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canSeeTags: bindViewer(canSeeTags),
      canViewAdminDashboardOrganizations: bindViewer(canViewAdminDashboardOrganizations),
    }),
    [bindViewer],
  );
};
